// reducers/staffReducer.js
export const staffReducer = (state = { staff: [] }, action) => {
  switch (action.type) {
    case "ALL_STAFF_REQUEST":
    case "CREATE_STAFF_REQUEST":
      return { ...state, loading: true };
    case "ALL_STAFF_SUCCESS":
      return { loading: false, staff: action.payload };
    case "CREATE_STAFF_SUCCESS":
      return { loading: false, success: true };
    case "ALL_STAFF_FAIL":
    case "CREATE_STAFF_FAIL":
      return { loading: false, error: action.payload };
    case "CLEAR_ERRORS":
      return { ...state, error: null, success: false };
    default:
      return state;
  }
};
